import React from 'react';
import mergeClassNames from 'utils/mergeClassNames';

export default class Map extends React.Component {
	render() {
		const params = this.props.embedWithoutKey
			? [
					['output', 'embed'],
					['q', this.props.address],
			  ]
			: [
					['key', process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ''],
					['q', this.props.address],
					['zoom', '10'],
			  ];

		const mapSearchParams = new URLSearchParams(params);

		const classNames = mergeClassNames(
			'map-embed aspect-square w-full rounded',
			this.props.className
		);

		const mapUrl = this.props.embedWithoutKey
			? `https://www.google.com/maps?${mapSearchParams.toString()}`
			: `https://www.google.com/maps/embed/v1/place?${mapSearchParams.toString()}`;

		return (
			<iframe
				allowFullScreen={true}
				className={classNames}
				frameBorder="0"
				loading="lazy"
				sandbox="allow-forms allow-popups allow-scripts"
				src={mapUrl}
				title="Property location map"
			/>
		);
	}
}
